import type { DocumentViewModel } from '../../document-viewer/models/document-viewer.models';
import type { TransactionDocumentViewModel } from '../../home/models/transaction-document.model';
import type { Transaction } from '../../home/models/transaction.model';

/** The document a deal opens on: its configured first display document, else its `-oc` document, else its first. */
export function getDefaultDocument(
  transaction: Pick<Transaction, 'documents' | 'firstDisplayDocument'> | undefined,
): TransactionDocumentViewModel | undefined {
  const documents = transaction?.documents ?? [];

  return (
    documents.find((document) => document.documentId === transaction?.firstDisplayDocument) ??
    documents.find((document) => document.documentId.endsWith('-oc')) ??
    documents[0]
  );
}

/** A shelf document's title as the blackline pickers show it: deal, document, and its date when that differs from the deal's. */
export function getDocumentTitle(document: DocumentViewModel | undefined): string {
  return [document?.transactionDisplayShortName, document?.documentDisplayName, document?.displayNameSuffix].filter(Boolean).join(' ');
}
